<template>
  <q-page class="flex-center">
    <div class="q-pa-md ">
      <h2>Novo modelo de email</h2>
      <q-select
        label="Tipo do email"
        :options="types"
        map-options
        emit-value
        v-model="form.type"
        option-value="value"
        option-label="label"
      />
      <br>
      <q-input label="Nome do modelo *" :rules="[required]" v-model="form.name"/>
      <q-input label="Assunto *" :rules="[required]" v-model="form.subject"/>
      <q-input v-if="form.type == 'Text'" :rules="[requiredText]" label="Saudação (obrigatório para texto)"
               v-model="form.greeting"/>
      <br>

      <br>
      <q-editor v-if="form.type == 'Text'" v-model="form.body" dense
                :fonts="{
        arial: 'Arial',
        arial_black: 'Arial Black',
        comic_sans: 'Comic Sans MS',
        courier_new: 'Courier New',
        impact: 'Impact',
        lucida_grande: 'Lucida Grande',
        times_new_roman: 'Times New Roman',
        verdana: 'Verdana'
      }"
                :toolbar="[
        [

          {
            label: $q.lang.editor.align,
            icon: $q.iconSet.editor.align,
            fixedLabel: true,
            options: ['left', 'center', 'right', 'justify']
          }
        ],
        ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript'],
        ['token', 'hr', 'link', 'custom_btn'],
        ['print', 'fullscreen'],
        [
          {
            label: $q.lang.editor.formatting,
            icon: $q.iconSet.editor.formatting,
            list: 'no-icons',
            options: [
              'p',
              'h1',
              'h2',
              'h3',
              'h4',
              'h5',
              'h6',
              'code'
            ]
          },
          {
            label: $q.lang.editor.fontSize,
            icon: $q.iconSet.editor.fontSize,
            fixedLabel: true,
            fixedIcon: true,
            list: 'no-icons',
            options: [
              'size-1',
              'size-2',
              'size-3',
              'size-4',
              'size-5',
              'size-6',
              'size-7'
            ]
          },
          {
            label: $q.lang.editor.defaultFont,
            icon: $q.iconSet.editor.font,
            fixedIcon: true,
            list: 'no-icons',
            options: [
              'default_font',
              'arial',
              'arial_black',
              'comic_sans',
              'courier_new',
              'impact',
              'lucida_grande',
              'times_new_roman',
              'verdana'
            ]
          },
          'removeFormat'
        ],
        ['quote', 'unordered', 'ordered'],

        ['undo', 'redo']
      ]"
      />
      <q-uploader
        :url="url"
        label="Imagem"
        :factory="uploadFactory"
        color="purple-10"
        send-raw
        with-credentials
        :max-file-size="maxSize"
        :auto-upload="true"
        @uploaded="finished"
        @finish="finished"
        @removed="form.file = ''"
      >
      </q-uploader>

      <br>
      <q-btn label="Preview" type="a" target="_blank" :href="preview" color="primary"/>
      <br><br>
      <q-btn label="Salvar" @click="salvar" color="primary"/>
    </div>
    <q-inner-loading :showing="loading">
      <q-spinner-dots size="50px" color="primary"/>
    </q-inner-loading>
  </q-page>
</template>

<script>
import { NEW_EMAIL_TEMPLATE, NEW_IMAGE } from '@/graphql/graphql'

export default {
  name: 'NewEmailTemplate',
  data () {
    return {
      loading: false,

      maxSize: 10 * 1024 * 1024 * 1024,
      url: '',
      form: {
        name: '',
        body: '',
        greeting: '',
        subject: '',
        type: '',
        file: ''
      },
      types: [
        { 'label': 'Texto', 'value': 'Text' },
        { 'label': 'Banner', 'value': 'Banner' }
      ]
    }
  },
  computed: {
    preview () {
      let query = []
      query.push('subject=' + encodeURIComponent(this.form.subject))
      query.push('emailMessage=' + encodeURIComponent(this.form.body))
      query.push('greeting=' + encodeURIComponent(this.form.greeting))
      query.push('type=' + encodeURIComponent(this.form.type))
      if (this.form.file) {
        query.push('file=' + encodeURIComponent(this.form.file))
      }
      return process.env.VUE_APP_HOST.replace('graphql', 'testTemplateEmail') + '?' + query.join('&')
    },
    requiredText () {
      return this.form.type === 'Text' || 'Campo obrigatorio'
    }
  },
  methods: {
    required (value) {
      return !!value || 'Campo obrigatorio'
    },
    pasteCapture (e) {
      e.preventDefault()
      console.log(e)
    },
    dropCapture (e) {
      e.preventDefault()
      console.log(e)
    },
    salvar () {
      this.loading = true
      this.$apollo.mutate({
        mutation: NEW_EMAIL_TEMPLATE,
        variables: {
          input: this.form
        }
      }).then(result => {
        // const data = result.data.login
        if (result.data.newEmailTemplate.hasOwnProperty('id')) {
          this.loading = false
          this.$router.push({ name: 'email-templates' })
          alert('Template de email Cadastrado')
        }
      }).catch((error) => {
        console.error(error)
      })
    },
    uploadFactory (file) {
      this.$store.dispatch('setLoading')
      return (

        this.$apollo.mutate({
          mutation: NEW_IMAGE,
          variables: { file: file[0] },
          context: {
            hasUpload: true
          },
          update: (store, data) => {
            console.log(data.data.newImage.url)
            this.form.file = data.data.newImage.url
          }
        })
          .catch(error => {
            console.error(error)
            const errors = { error }
            this.alertError = true
            this.titleError = errors.error.graphQLErrors[0].message
            this.messageError = errors.error.graphQLErrors[0].debugMessage
            console.error(errors.error.graphQLErrors[0].trace[0])
          })

      )
      // return new Promise(resolve, reject);
    },
    finished () {
      this.$store.dispatch('setLoading')
      this.openDialog = false
    }
  }
}
</script>
